<template>
  <WithTopAndBottom>
    <component class="meu" :is="Meu" >
    <div class="bgs-[url('@a/assets/images/bg_meu.png'),0_40%,100%_auto] mt-6">
      <div class="flex-between p-[0_30px_16px] gap-3 text-13 [&_img]:wh-[7.5_8]">
        <div class="flex-center-y gap-2" @click="$router.push('/deposito')">
          <img src="@a/assets/images/i_deposito.png" /> Depósito
        </div>
        <div class="flex-center-y gap-2" @click="handleSaqueClick($router)">
          <img src="@a/assets/images/i_saque.png" /> Saque
        </div>
        <div class="flex-center-y gap-2" @click="$router.push('/cpf')">
          <img src="@a/assets/images/i_cpf.png" /> CPF
        </div>
      </div>

      <div class="flex-between gap-2 px-5 pb-15 order-2">
        <div class="flex-center-col-x pt-4 flex-1">
          <strong class="text-16 font-[600] leading-22 mb-1">{{ formatter().format(wallet.balance) }}</strong>
          <span class="text-[var(--theme-primary-gray)]">Saldo</span>
        </div>
        <div class="flex-center-col-x pt-4 flex-1">
          <strong class="text-16 font-[600] leading-22 mb-1">{{ formatter().format(wallet.totalReward) }}</strong>
          <span class="text-[var(--theme-primary-gray)]">Bônus da Atividade</span>
        </div>
        <div class="flex-center-col-x pt-4 flex-1">
          <strong class="text-16 font-[600] leading-22 mb-1">{{ formatter().format(wallet.totalAgentCommission)
            }}</strong>
          <span class="text-[var(--theme-primary-gray)]">Bônus do Agente</span>
        </div>
      </div>

      <div class="px-4 flex flex-wrap order-3">
        <div :class="[
          'flex-center-col size-17 mb-2.5 px-1',
          item.rewardStatus == 'Awarded' && 'withRedPoint',
        ]" v-for="item in activityList" :key="item.id">
          <Image :src="item.menuLogo" alt="" class="size-8 mb-1" @click="gotoActivity(item, $router)">
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </Image>
          <span class="w-full truncate text-center">{{ item.activityConfigLogo }}</span>
        </div>
      </div>
    </div>
    </component>
  </WithTopAndBottom>
</template>

<script setup lang="ts">
  import Meu from '@/components/Meu/index.vue'
  import WithTopAndBottom from '@a/layouts/withTopAndBottom.vue'
  import { handleSaqueClick } from "@/utils/userStatusUtils.ts";
  import { gotoActivity } from "@/utils";
  import { formatter } from "@/utils";
  import { useWallet, useActivityList } from "@/store";

  const activityList = ref(useActivityList().activityList)
  const wallet = computed(() => useWallet().wallet)
</script>

<style scoped>
.meu{
  --bn-bg: var(--theme-gray-green15);
  --servico-bg: url('@a/assets/images/i_serv.png');
  --message-bg: url('@a/assets/images/i_message.png');
}
</style>
